// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as City$PorterinFeature from "../../../../shared/core/helpers/City.mjs";
import * as UtmUtils$PorterinFeature from "../../utils/utm-utils/UtmUtils.mjs";
import * as Requirement$PorterinFeature from "../../../../shared/core/domain/entities/Requirement.mjs";
import * as FeParamsHelper$PorterinFeature from "../../../../shared/core/helpers/FeParamsHelper.mjs";
import * as QueryParamsConstructor$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs";

function getUtmParams(param_value) {
  var utm_obj = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(utm_obj, param), "");
          if (param_value_status.length === 0 && index < param_value.length) {
            utm_obj[param] = Caml_array.get(param_value, index);
            return ;
          }
          
        }), UtmUtils$PorterinFeature.utm_params_keys);
  return Belt_Option.getWithDefault(QueryParamsConstructor$Catalyst.create(utm_obj), "");
}

function getUtmParamsEstimateFormEdit(param_value) {
  var utm_obj = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  var new_dict = {};
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(utm_obj, param), "");
          if (param_value_status.length === 0 && index < param_value.length) {
            new_dict[param] = Caml_array.get(param_value, index);
          } else {
            new_dict[param] = param_value_status;
          }
        }), UtmUtils$PorterinFeature.utm_params_keys);
  return Belt_Option.getWithDefault(QueryParamsConstructor$Catalyst.create(new_dict), "");
}

function getDefaultParamsValues(source) {
  return [
          "website_fare_estimate_ssr",
          "default_" + source,
          "default_" + source,
          "default_" + source,
          ""
        ];
}

function getUtmKeyValues(source) {
  var url_params = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  var default_param_values = getDefaultParamsValues(source);
  return $$Array.mapi((function (index, param) {
                var param_value = Belt_Option.getWithDefault(Js_dict.get(url_params, param), "");
                var match = param_value.length === 0;
                if (match) {
                  if (index < default_param_values.length) {
                    return [
                            param,
                            Caml_array.get(default_param_values, index)
                          ];
                  } else {
                    return [
                            param,
                            ""
                          ];
                  }
                } else {
                  return [
                          param,
                          param_value
                        ];
                }
              }), UtmUtils$PorterinFeature.utm_params_keys);
}

function fareEstimateResultRedirectUrlOms(redirect_url, service_category, source, is_desktop) {
  return redirect_url + "&service_category=" + service_category + "&is_device_mobile=" + (
          is_desktop ? "false" : "true"
        ) + "&landing_page=nw&" + getUtmParams(getDefaultParamsValues(source));
}

function fareEstimateResultRedirectUrlEdit(redirect_url, service_category, source, is_desktop) {
  return redirect_url + "&service_category=" + service_category + "&is_device_mobile=" + (
          is_desktop ? "false" : "true"
        ) + "&landing_page=nw&" + getUtmParamsEstimateFormEdit(getDefaultParamsValues(source));
}

function replaceFareEstimate(input) {
  return Js_string.replace("fare_estimate_mob", "fare-estimate", input);
}

function fareEstimateV2RedirectUrl(redirect_url, service_category, source, is_desktop) {
  var fare_estimate_url = Js_string.replace("fare_estimate_mob", "fare-estimate", redirect_url);
  return fare_estimate_url + "&service_category=" + service_category + "&is_device_mobile=" + (
          is_desktop ? "false" : "true"
        ) + "&landing_page=nw&" + getUtmParamsEstimateFormEdit(getDefaultParamsValues(source));
}

function toApiInput(fare_estimate_form, cityOpt, param) {
  var city = cityOpt !== undefined ? cityOpt : "";
  var form_data = fare_estimate_form._0;
  return {
          geo_region: City$PorterinFeature.cityToGeoRegionId(city).toString(),
          pickup_address: form_data.pickup_address,
          drop_address: form_data.drop_address,
          name: form_data.name,
          mobile: form_data.mobile,
          requirement: Requirement$PorterinFeature.requirementToString(form_data.requirement),
          service_category: form_data.service_category
        };
}

function getCallbackReqKeyValuePairs(data) {
  return [
          [
            "result",
            Pervasives.string_of_bool(data.result)
          ],
          [
            "prev_callback_req_id_present",
            Pervasives.string_of_bool(data.prev_callback_req_id_present)
          ],
          [
            "callback_request_id",
            data.callback_request_id
          ],
          [
            "is_existing_cust",
            Pervasives.string_of_bool(data.is_existing_cust)
          ],
          [
            "lead_entry_created",
            Pervasives.string_of_bool(data.lead_entry_created)
          ]
        ];
}

function getParamValue(params, key, $$default) {
  return Belt_Option.getWithDefault(Js_dict.get(UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(params)), key), $$default);
}

function makeCallbackDataQueryParams(callback_request_data) {
  return getCallbackReqKeyValuePairs(callback_request_data).reduce((function (param_url, param) {
                return param_url + ("&" + param[0] + "=" + window.encodeURIComponent(param[1]) + "");
              }), "");
}

function updateRedirectUrl(data, updated_url) {
  return Belt_Result.map(data, (function (success_data) {
                return {
                        redirect_url: updated_url,
                        callback_request_data: success_data.callback_request_data
                      };
              }));
}

function fareEstimateProviderValue(state, dispatch) {
  return {
          fare_result: state.fare_result,
          set_fare_result: (function (results) {
              Curry._1(dispatch, {
                    TAG: /* SetFareResult */0,
                    _0: results
                  });
            }),
          query_params: state.query_params,
          is_valid_params: state.is_valid_params,
          is_retry: state.is_retry,
          set_is_retry: (function (retry) {
              Curry._1(dispatch, {
                    TAG: /* SetIsRetry */3,
                    _0: retry
                  });
            }),
          selected_vehicle: state.selected_vehicle,
          set_selected_vehicle: (function (selected_vehicle) {
              Curry._1(dispatch, {
                    TAG: /* SetSelectedVehicle */4,
                    _0: selected_vehicle
                  });
            }),
          selected_vehicle_fare: state.selected_vehicle_fare,
          set_selected_vehicle_fare: (function (selected_vehicle_fare) {
              Curry._1(dispatch, {
                    TAG: /* SetSelectedVehicleFare */5,
                    _0: selected_vehicle_fare
                  });
            }),
          does_customer_exist: state.does_customer_exist,
          set_does_customer_exist: (function (does_customer_exist) {
              Curry._1(dispatch, {
                    TAG: /* SetDoesCustomerExist */6,
                    _0: does_customer_exist
                  });
            })
        };
}

function enableBookingFlow(mobile, is_desktop) {
  return !is_desktop;
}

function redirectBookingFlow(is_booking_flow, redirect_url, service_category, source, is_desktop, page) {
  var url = is_booking_flow ? fareEstimateV2RedirectUrl(redirect_url, service_category, source, is_desktop) : fareEstimateResultRedirectUrlOms(redirect_url, service_category, source, is_desktop);
  FeParamsHelper$PorterinFeature.saveToStoreAndRedirect(url, page);
}

function redirectOrderReview(url) {
  FeParamsHelper$PorterinFeature.saveToStoreAndRedirect(url, "OrderReview");
}

export {
  getUtmParams ,
  getUtmParamsEstimateFormEdit ,
  getDefaultParamsValues ,
  getUtmKeyValues ,
  fareEstimateResultRedirectUrlOms ,
  fareEstimateResultRedirectUrlEdit ,
  replaceFareEstimate ,
  fareEstimateV2RedirectUrl ,
  toApiInput ,
  getCallbackReqKeyValuePairs ,
  getParamValue ,
  makeCallbackDataQueryParams ,
  updateRedirectUrl ,
  fareEstimateProviderValue ,
  enableBookingFlow ,
  redirectBookingFlow ,
  redirectOrderReview ,
}
/* City-PorterinFeature Not a pure module */
